import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useCookies } from "react-cookie";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";

import { logIn } from "@/services/API/Authorization";
import { inputStyles } from "@/utils/constants";
import { setLoading } from "@/store/ui/ui";
import Button from "@/shared/components/Button/Button";

import { ILoginForm } from "@/shared/interfaces/auth";

import LogoDiv from "./LogoDiv";

import "./LoginForm.scss";
import Title from "@/shared/components/Title/Title";

const schema = yup.object().shape({
    email: yup
        .string()
        .email("Невірний формат введення пошти")
        .required("Електронна пошта обов*язкова"),
    password: yup
        .string()
        .min(7, "Мінімальна довжина паролю складає 6 символів")
        .required("Пароль обов*язковий!"),
});

export default function LoginForm() {
    const navigate = useNavigate();
    const [, setCookie] = useCookies();
    const [togglePassword, setTogglePassword] = useState<boolean>(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });
    const dispatch = useDispatch();
    const onSubmit = async (data: ILoginForm): Promise<void> => {
        const dataObg = {
            email: data.email,
            password: data.password,
        };
        dispatch(setLoading(true));
        const userAuth = await logIn(dataObg);
        dispatch(setLoading(false));

        if (userAuth?.data?.name) {
            reset();
            const arr = userAuth.data.name.split(" ").filter(Boolean);
            let initials = "";
            let username = "";

            if (arr.length >= 2) {
                initials = arr[1][0].toUpperCase() + arr[0][0].toUpperCase();
                username = arr[1] + " " + arr[0];
            } else if (arr.length === 1) {
                initials = arr[0].slice(0, 2).toUpperCase();
                username = arr[0];
            } else {
                initials = "";
                username = "";
            }
            if (userAuth?.isAdmin) {
                setCookie("role", "admin", { maxAge: 43200 });
            }
            setCookie("isAuthorized", true, { maxAge: 43200 });
            setCookie("letters", initials, { maxAge: 43200 });
            setCookie("username", username || "Гість", { maxAge: 43200 });
            setCookie("email", userAuth.data.email, { maxAge: 43200 });
            navigate("/schedule");
        } else toast.error(userAuth.message);
    };

    return (
        <section className='form_container'>
            <LogoDiv />
            <Title tag='h1' text={"Вхід"} />
            <form
                onSubmit={handleSubmit(onSubmit)}
                action=''
                method='post'
                target='_blank'
                className='form'
            >
                <TextField
                    type='email'
                    {...register("email")}
                    error={!!errors.email}
                    id='outlined-error-helper-text'
                    label='Електронна пошта'
                    variant='outlined'
                    sx={{
                        ...inputStyles.root,
                        marginBottom: 2,
                        width: "100%",
                    }}
                    helperText={errors.email ? errors.email.message : ""}
                />
                <div className='input_password_container'>
                    <TextField
                        type={togglePassword ? "text" : "password"}
                        {...register("password")}
                        error={!!errors.password}
                        id='outlined-error-helper-text'
                        label='Пароль'
                        sx={{
                            ...inputStyles.root,
                            mb: "24px !important",
                            width: "100%",
                        }}
                        helperText={
                            errors.password ? errors.password.message : ""
                        }
                    />
                    <img
                        onClick={() =>
                            setTogglePassword(prevstate => !prevstate)
                        }
                        className='logo_see_password'
                        src={
                            togglePassword
                                ? "./loginpage/password-ewe.svg"
                                : "./loginpage/password-ewe-2.svg"
                        }
                        alt='logo eye dont seen'
                    />
                </div>

                <Button text={"Увійти"} variant='approved' type='submit' />
            </form>
        </section>
    );
}
